(function($) {
  'use strict';

  function toggleVitalsForm($container, $buttonContainer, show) {
    if (!$container.length || !$buttonContainer.length) return;

    var inputs = $container.find('input, select, textarea, button');

    if (show) {
      $container.removeClass('hidden');
      $buttonContainer.addClass('hidden');
      inputs.prop('disabled', false);
    } else {
      $container.addClass('hidden');
      $buttonContainer.removeClass('hidden');
      inputs.prop('disabled', true);
    }
  }

  function initVisitVitals() {
    var $container = $('.js-vitals-form-container');
    var $buttonContainer = $('.js-add-vitals-button-container');
    if (!$container.length || !$buttonContainer.length) return;

    var hasVitals = $container.data('has-vitals') === true;

    // Set initial state to match the server-rendered intent.
    toggleVitalsForm($container, $buttonContainer, hasVitals);

    // Bind the Add / Remove buttons (replace inline onclick handlers).
    $buttonContainer.on('click', '.js-add-vitals', function(event) {
      event.preventDefault();
      toggleVitalsForm($container, $buttonContainer, true);
    });

    $container.on('click', '.js-remove-vitals', function(event) {
      event.preventDefault();
      toggleVitalsForm($container, $buttonContainer, false);
    });
  }

  $(document).ready(initVisitVitals);
  $(document).on('page:load', initVisitVitals);
})(jQuery);
